import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import top_img from "../../assets/images/Reception.png";
// import vdo from "../../assets/video/0_Xray_Ray_1920x1080.mp4";
// import vdo2 from "../../assets/video/nuclear_1.mp4";
// import Hospital from "../../assets/images/CDCHospital.png";
gsap.registerPlugin(ScrollTrigger);

const WelComeCDC = () => {
  const imgContainerRef = useRef(null);
  const hospitalImgRef = useRef(null);

  useEffect(() => {
    const topImage = imgContainerRef.current;
    const hospitalImage = hospitalImgRef.current;

    gsap.to(topImage, {
      width: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: topImage,
        start: "top 50%",
        end: "+=300",
        scrub: true,
      },
    });

    gsap.to(hospitalImage, {
      width: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: hospitalImage,
        start: "top 50%",
        end: "+=300",
        scrub: true,
      },
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <div className="flex justify-center items-center">
      <div className=" lg:w-[90%] 2xl:w-[95%] 3xl:w-[90%] w-full flex xl:flex-row flex-col xl:gap-5 gap-8 items-center 2xl:pt-[14rem] xl:pt-[12rem] pt-[6rem]  text-white">
        <div className="flex flex-col items-center 2xl:text-7xl xl:text-6xl lg:text-7xl md:text-6xl text-[8.5vw] mb-8 xl:mb-0 capitalize -tracking-wider font-semibold justify-center md:gap-4 gap-0 xl:w-1/2 w-full">
          <p>Physician-owned</p>
          <p>Trusted by physicians</p>
          <p>dedicated to patients</p>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="100"
          className="xl:text-[1.5rem] md:text-[1.125rem] xl:w-1/2 w-full text-[1.125rem] leading-normal lg:ps-0 md:px-8 px-4 xl:text-left text-center font-robout"
        >
          <h3 className="text-3xl md:text-4xl mb-8 font-bold">
            Our Philosophy{" "}
          </h3>
          <p>
            CDC follows a radiologist-led model where every aspect of diagnostic
            imaging—conducting the scan, analyzing results, and preparing the
            report is managed by a board-certified Radiologist who is present
            on-site. This approach ensures clarity, precision, and
            accountability, unlike large diagnostic chains that often outsource
            scans overseas, leaving uncertainty about whether interpretations
            are handled by radiologists or technicians.
          </p>
          <p className="mt-6">
            {" "}
            We value the strong relationships between patients and referring
            physicians, fostering a collaborative environment where your health
            and well-being remain the top priority.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelComeCDC;
